(() => {
  const qs  = (r, s) => r.querySelector(s);
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));

  const apply = (vs) => {
    if (!vs || vs.getAttribute('data-runink-city-map') !== 'true') return;

    const formatSel = qs(vs, 'select[name="options[FORMAT]"]');
    const framingSel = qs(vs, 'select[name="options[FRAMING]"]');
    const sizeSel = qs(vs, 'select[name="options[SIZE]"]');
    if (!formatSel || !framingSel) return;

    const framingWrap = framingSel.closest('.product-form__input');
    if (!framingWrap) return;

    const isDigital = formatSel.value === 'DIGITAL DOWNLOAD';
const isFiveBySeven = sizeSel && sizeSel.value === '5x7';

const hideFraming = isDigital || isFiveBySeven;
framingWrap.style.display = hideFraming ? 'none' : '';

// Note: show ONLY for PRINT + 5x7
const note = vs.querySelector('.runink-framing-note');
if (note) note.style.display = (!isDigital && isFiveBySeven) ? '' : 'none';
};

  const initOne = (vs) => {
    if (!vs || vs.getAttribute('data-runink-city-map') !== 'true') return;
    if (vs.dataset.runinkCityInit === '1') return;
    vs.dataset.runinkCityInit = '1';

    // Apply on any change inside variant-selects
    vs.addEventListener('change', () => apply(vs));

    // Apply once now
    apply(vs);
  };

  const boot = () => {
    // Init any current City Race Map variant pickers
    qsa(document, 'variant-selects[data-runink-city-map="true"]').forEach(initOne);

    // Dawn swaps product HTML when variants change; re-apply after swaps
    const mo = new MutationObserver(() => {
      qsa(document, 'variant-selects[data-runink-city-map="true"]').forEach((vs) => {
        // re-init if it’s a new node
        if (vs.dataset.runinkCityInit !== '1') initOne(vs);
        // and always re-apply in case FRAMING got re-rendered
        apply(vs);
      });
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
